import React from "react";
import BlogBoxHome from "./BlogBoxHome";
import { useAuth } from "../../Store/AuthContext";
import { BlogLimitData } from "../../APIS/FetchAPIs";

export default function BlogSectionHome() {
  const { RendomTokenfetch } = useAuth();
  const [LatestBlogLimit, loading] = BlogLimitData(RendomTokenfetch);
  return (
    <>
      <section
        className="blog-section section-padding "
        style={{ backgroundImage: `url('images/propertie-bg.jpg')` }}
      >
        <div className="container">
          <div className="row section-title">
            <div className="col col-md-8 col-md-offset-2">
              <h2>Latest news</h2>
              <p>
                We deliver true results, focusing on strategic decisions and
                practical actions tailored to our clients' unique reality. We
                engage all levels of an organization from day one.
              </p>
            </div>
          </div>

          <div className="row blog-section-grids">
            {loading ? (
              <p className="text-center">Loading blogs...</p>
            ) : LatestBlogLimit.length > 0 ? (
              LatestBlogLimit.map((val) => (
                <BlogBoxHome key={val.id || val._id} blogdata={val} />
              ))
            ) : (
              <p className="text-center">No blogs available right now.</p>
            )}
          </div>
        </div>
      </section>
    </>
  );
}
